import UsageTrackerContainer from './UsageTrackingContainer';
import { checkUrlForUUID } from './uuidUtils';
import { hasAcceptedCookies } from './hasAcceptedCookies';
import AnonymousUsageTrackerContainer from './AnonymousUsageTrackerContainer';
import { getHasTrackingByUuid } from './trackingUtils';
export const getTracker = () => {
  const hasTrackingByUuid = getHasTrackingByUuid();
  const acceptedCookies = (hasAcceptedCookies() || UsageTrackerContainer.areCookiesAccepted) && !checkUrlForUUID();
  const trackByCookies = acceptedCookies && !hasTrackingByUuid;
  return trackByCookies || UsageTrackerContainer.identifiableTrackingEnabled ? UsageTrackerContainer : AnonymousUsageTrackerContainer;
};